/**
 * Error that is thrown when a file type is not supported
 */
export class FileTypeNotSupportedError extends Error {
    constructor(message, file) {
        super(message);
        Object.defineProperty(this, "file", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = 'FileTypeNotSupportedError';
        this.file = file;
    }
}
//# sourceMappingURL=FileTypeNotSupportedError.js.map